import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { SyncError } from './admin-dashboard.model';

@Injectable({
  providedIn: 'root'
})
export class AdminDashboardService {
  private baseUrl = `${environment.adminConfig.apiUri}/AdminDashboard`;

  constructor(private http: HttpClient) {}

  getSyncErrors(fromDate?: Date, toDate?: Date): Observable<SyncError[]> {
    let params = new HttpParams();
    
    if (fromDate) {
      params = params.set('fromDate', fromDate.toISOString());
    }
    if (toDate) {
      params = params.set('toDate', toDate.toISOString());
    }

    return this.http.get<SyncError[]>(`${this.baseUrl}/sync-errors`, { params });
  }
}
